import { baseBackendUrl } from './baseService';
import { ProofreadContentType, ProofreadResult, RewriteResult } from '../types/proofread';

export const contentProofreadingService = {
  proofread: async (content: string, contentType: ProofreadContentType, token: string): Promise<ProofreadResult> => {
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;

    const response = await fetch(`${baseBackendUrl}/api/content/proofread`, {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify({ content, contentType }),
    });

    if (!response.ok) throw new Error('Failed to proofread content');
    return response.json();
  },

  // isHtml asks Grok to keep the rich-text markup so the result can be loaded straight back into the editor.
  rewrite: async (content: string, contentType: ProofreadContentType, isHtml: boolean, token: string): Promise<string> => {
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;

    const response = await fetch(`${baseBackendUrl}/api/content/rewrite`, {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify({ content, contentType, isHtml }),
    });

    if (!response.ok) throw new Error('Failed to rewrite content');
    const result: RewriteResult = await response.json();
    return result.rewrittenText;
  }
};
